import dynamic from 'next/dynamic'
import s from './style.module.css'

const VideoPlayer = dynamic(() => import('react-player'), { ssr: false })

export default function VideoBlock({ url }) {
	return (
		<section className={s.videoBlock}>
			<div className={s.videoContainer}>
				<VideoPlayer url={url} controls width="100%" height="100%" />
			</div>
		</section>
	)
}
